<template>
  <TopPagePane />
</template>

<script setup>
import TopPagePane from "../components/TopPagePane/index.vue";
</script>
